'use client';

import type { AuthFormAlert } from '@/lib/auth-errors';

export function AuthFormAlerts({ message, hint, hintTone = 'warning' }: AuthFormAlert) {
  if (!message && !hint) return null;

  return (
    <div className="space-y-1.5">
      {message ? (
        <div
          role="alert"
          className="rounded-2xl border border-rose-200 bg-rose-600 px-3 py-2 text-sm text-white dark:bg-rose-600"
        >
          {message}
        </div>
      ) : null}
      {hint ? (
        <p
          role="status"
          className={
            hintTone === 'warning'
              ? 'px-0.5 text-xs leading-snug text-amber-800 /90'
              : 'px-0.5 text-xs leading-snug text-[var(--app-text-soft)]'
          }
        >
          {hint}
        </p>
      ) : null}
    </div>
  );
}
